import { CrossIcon } from '../../../../assets/icons';
import Button from '../../../../components/Button';
import SideBySideTokens from '../../../../components/SideBySideTokens/SideBySideTokens';
import usePoolState from '../../../../context/pool/usePoolState';

const PoolExposure = () => {
    const { selectedLiquidityPool, toggleExposure } = usePoolState();

    return selectedLiquidityPool ? (
        <div className='exposure'>
            <Button onClick={toggleExposure} variant='transparent'>
                <CrossIcon />
            </Button>
            <div className='pool-name'>{selectedLiquidityPool.name} Exposure</div>
            <SideBySideTokens tokens={selectedLiquidityPool.poolAssets} />
        </div>
    ) : null;
};

export default PoolExposure;
